<div class="sp-p-16">
  <div class="sp-mb-48">
    <h4 class="sp-mb-12">Basic Usage:</h4>
    <button ui-button [buttonType]="'primary'" (click)="createBasicNotification()">Open the notification box</button>
  </div>

  <div class="sp-mb-48">
    <h4 class="sp-mb-12">Typed Notifications:</h4>
    <button ui-button (click)="createNotification('success')">Success</button>
    <button ui-button (click)="createNotification('info')">Info</button>
    <button ui-button (click)="createNotification('warning')">Warning</button>
    <button ui-button (click)="createNotification('error')">Error</button>
  </div>

  <div class="sp-mb-48">
    <h4 class="sp-mb-12">Notifications From Template:</h4>
    <button ui-button [buttonType]="'primary'" (click)="ninja()">Open the notification box</button>
    <ng-template let-fruit="data">
      It's a
      <ui-tag [uiColor]="fruit.color">{{ fruit.name }}</ui-tag>
      <button ui-button nzSize="small">Cut It!</button>
    </ng-template>
  </div>

  <div class="sp-mb-48">
    <h4 class="sp-mb-12">Notifications Positioning:</h4>
    <button ui-button (click)="createBasicNotification('topLeft')" iconType="primary">
      <ui-icon uiType="outline:radius-upleft"></ui-icon>
      topLeft
    </button>
    <button ui-button (click)="createBasicNotification('topRight')" iconType="primary">
      <ui-icon uiType="outline:radius-upright"></ui-icon>
      topRight
    </button>
    <ui-divider></ui-divider>
    <button ui-button (click)="createBasicNotification('bottomLeft')" iconType="primary">
      <ui-icon uiType="outline:radius-bottomleft"></ui-icon>
      bottomLeft
    </button>
    <button ui-button (click)="createBasicNotification('bottomRight')" iconType="primary">
      <ui-icon uiType="outline:radius-bottomright"></ui-icon>
      bottomRight
    </button>
  </div>
</div>
